<!-- Large/card discount display-->
<glxy-alert type="info" size="small" *ngIf="size.toLowerCase() === 'large'">
  <strong>Active Discounts</strong>
  <glxy-alert-extended>
    <div *ngFor="let discount of discountsFormatted">
      {{ discount }}
    </div>
  </glxy-alert-extended>
</glxy-alert>
<!-- Small/table/list discount display-->
<div *ngIf="size.toLowerCase() === 'regular'">
  <strong>Active Discounts</strong>
  <div *ngFor="let discount of discountsFormatted">
    <li>{{ discount }}</li>
  </div>
</div>
